<template>
  <div>
    <ZipcodeSlideout
      v-if="zipcodeSlideoutShown && activeSlideout === productId"
      :id="productId"
      v-model:zipCode="zipCode"
      :page="page"
      @update:zipCode="onUpdateZipcode"
      @closed:zipCode="onSlideoutClose"
    />
  </div>
</template>

<script setup>
// @ts-ignore
import ZipcodeSlideout from '@common-vue/fulfillment/src/components/zipcodeSlideout/ZipcodeSlideout';
import { nextTick } from 'vue';
import { useProduct } from '@modules/product';
import { useAvailabilityBigTicket } from '@modules/availability/composables';
import { useFulfilmentData } from '../../composables/useFulfilmentData';

const { zipCode } = useFulfilmentData();
const { productId } = useProduct();
const page = 'pdp';

const {
  zipcodeSlideoutShown, previouslyFocusedElement, setStoreZipCode, activeSlideout,
} = useAvailabilityBigTicket();

/** @param {string} slideoutZipCode */
const onUpdateZipcode = (slideoutZipCode) => {
  setStoreZipCode(slideoutZipCode);
  zipcodeSlideoutShown.value = false;
  activeSlideout.value = false;
};

const onSlideoutClose = async () => {
  zipcodeSlideoutShown.value = false;
  activeSlideout.value = false;
  await nextTick();
  previouslyFocusedElement.value?.focus();
};
</script>
